import * as Sentry from '@sentry/browser';
import _debounce from 'lodash/debounce';

import { abortController, reinitController } from '@/utils/abortController';
import router from '@/router';
import { useAuthStore } from '@/stores/useAuthStore';
import { useStaticStore } from '@/stores/useStaticStore';
import { useUserStore } from '@/stores/useUserStore';
import { showWarningNotification } from '@/helpers/notifiers';
import * as routeNames from '@/constants/routeNames';

export async function btnLogout(): Promise<void> {
  const staticStore = useStaticStore();
  const authStore = useAuthStore();
  const userStore = useUserStore();

  authStore.removeAuthData();
  // We need to abort all requests that are currently in progress because the user is logged out
  abortController();
  // Abort controller should be reinitialized after the logout because previous instance is aborted
  reinitController();
  userStore.removeUser();
  staticStore.clearStaticState();
  Sentry.setUser(null);
  if (router.currentRoute.value.name !== routeNames.LOGIN) {
    await router.push({ name: routeNames.LOGIN });
  }
}

export const debouncedExpiredLogout = _debounce(expiredLogout, 500, {
  leading: true,
  trailing: false,
});

export async function expiredLogout(): Promise<void> {
  const authStore = useAuthStore();

  // First of all, we need to abort all requests
  abortController();
  // LogOut procedure
  showWarningNotification({ title: 'The session has expired' });
  authStore.removeAuthData();
  // Abort controller should be reinitialized after the logout because previous instance is aborted
  reinitController();
  if (router.currentRoute.value.name !== routeNames.LOGIN) {
    await router.push({ name: routeNames.LOGIN });
  }
}
